export default "__VITE_ASSET__CesiYzmp__"